import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Live notes timeline for a lead, newest first.
export function subscribeNotes(leadId, onChange, onError) {
  if (!leadId) { onChange([]); return () => {}; }
  const q = query(collection(db, 'leads', leadId, 'notes'), orderBy('ts', 'desc'));
  return onSnapshot(
    q,
    (snap) => onChange(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => (onError ? onError(err) : console.error('notes listener error', err)),
  );
}
